import { render, staticRenderFns } from "./DlgPressDelete.vue?vue&type=template&id=0a7e135e&scoped=true&"
import script from "./DlgPressDelete.vue?vue&type=script&lang=js&"
export * from "./DlgPressDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e135e",
  null
  
)

export default component.exports